import request from '@/utils/request';

/**
 * 全局搜索
 */
export function searchGlobal(params) {
  return request({
    url: '/search/global',
    method: 'get',
    params,
  });
}
